// eslint-disable-next-line import/prefer-default-export
export const createSportConfig = ({
    type,
    selection,
    event,
    icons,
    assets,
    features,
    mapSelectionToCardProps,
    labelOverrides = {}
}) => {
    // Generate standard labels based on nouns
    const defaultLabels = {
        selectionNoun: selection.noun,
        selectionNounCapitalized: selection.nounCapitalized,
        selectionNounPlural: selection.nounPlural,
        selectionNounPossessive: selection.nounPossessive,
        eventNoun: event.noun,
        eventNounPlural: event.nounPlural,

        assignedTitle: sweepName =>
            `My ${sweepName} Sweepstake ${selection.nounCapitalized}`,

        revealMessage: sweepName =>
            `And your ${sweepName} Sweepstake ${selection.noun} is\u2026`,

        shareMessage: (title, prize) =>
            `I've just entered the ${title} Sweepstake ${icons.sportIcon} don't miss your chance to enter for free and be in with a chance of winning ${prize}! #ITV7 itv7sweepstake.itv.com 18+ and UK only, T&Cs apply.`,

        shareTitle: prize => `Join the ${event.actionNoun} for ${prize}!`,

        winnersSubtitle: (eventName, count) =>
            `${eventName} Winner${count > 1 ? 's' : ''}`,

        winnerAnnouncementXHandle: '@ITV7Racing',
        winnerAnnouncementXUrl: 'https://x.com/ITV7Racing'
    };

    // Merge default labels with any custom overrides
    const labels = { ...defaultLabels, ...labelOverrides };

    return {
        type,
        labels,
        icons,
        assets,
        features,
        mapSelectionToCardProps
    };
};
